import React from 'react';
import PropTypes from 'prop-types';

const PlaylistPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M4.5 23h23a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-23a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zm10-16.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 14 9V7a.5.5 0 0 1 .5-.5zm-10 8h23a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-23A.5.5 0 0 1 4 17v-2a.5.5 0 0 1 .5-.5zM4.25 3.51c0-.497.364-.658.81-.361l6.368 4.238c.448.298.425.753-.045 1.014l-6.278 3.482c-.472.262-.855.068-.855-.425V3.509z"
    />
  );
};

PlaylistPath.propTypes = {
  fill: PropTypes.string,
};

export default PlaylistPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/video-features/playlist.jsx